import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginForm from './Components/Login/LoginForm';
import GoogleCallbackComponent from './Components/GoogleCallbackComponent';
import CleverCallbackComponent from './Components/CleverCallbackComponent'
import Dashboard from './Components/Dashboard/Dashboard';

const AppRouter = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginForm />} />
        <Route path="/auth/google/callback" element={<GoogleCallbackComponent />} />
        <Route path="/dashboard" element={<Dashboard />} />


        <Route path="/auth/clever/callback" element={<CleverCallbackComponent />} />

      </Routes>
    </Router>
  );
};

export default AppRouter;
